/*
 * Copyright Camunda Services GmbH and/or licensed to Camunda Services GmbH under
 * one or more contributor license agreements. See the NOTICE file distributed
 * with this work for additional information regarding copyright ownership.
 * Licensed under the Camunda License 1.0. You may not use this file
 * except in compliance with the Camunda License 1.0.
 */

export const selectElementAndFocusField = async ({ modeler, element, entryId }) => {
  modeler.get('selection').select(element);

  // TODO(philippfromme): properties panel is rendered asynchronously so timeout
  // is required to ensure that entry is rendered
  setTimeout(() => {
    modeler.get('eventBus').fire('propertiesPanel.showEntry', {
      focus: true,
      id: entryId
    });
  });
};

export const isExpression = (str) => {
  return str?.trim()?.startsWith('=');
};
